import React from 'react';

const CarouselContext = React.createContext({});

export default CarouselContext;
